/**
 * Mapping des icônes pour l'application
 * Utilise react-icons pour des icônes professionnelles et sobres
 */

import {
  FiBarChart2,
  FiEdit,
  FiUsers,
  FiTrendingUp,
  FiPhone,
  FiTarget,
  FiBell,
  FiFileText,
  FiSettings,
  FiPlus,
  FiSearch,
  FiFilter,
  FiDownload,
  FiUpload,
  FiEdit2,
  FiEye,
  FiEyeOff,
  FiTrash2,
  FiCheck,
  FiX,
  FiSave,
  FiRefreshCw,
  FiLock,
  FiUnlock,
  FiLogOut,
  FiUser,
  FiAward,
  FiBookOpen,
  FiCalendar,
  FiClock,
  FiMail,
  FiMapPin,
  FiDollarSign,
  FiBriefcase,
  FiHome,
  FiPrinter,
  FiShare2,
  FiCopy,
  FiAlertCircle,
  FiAlertTriangle,
  FiCheckCircle,
  FiInfo,
  FiChevronDown,
  FiChevronUp,
  FiChevronLeft,
  FiChevronRight,
  FiXCircle,
  FiMenu,
  FiGrid,
  FiList,
  FiCheckSquare,
  FiSquare,
} from 'react-icons/fi';

import {
  HiOutlineChartBar,
  HiOutlineDocumentText,
  HiOutlineUserGroup,
  HiOutlineChartPie,
  HiOutlinePhone,
  HiOutlineCog6Tooth,
  HiOutlineBell,
  HiOutlineDocument,
  HiOutlineHome,
} from 'react-icons/hi2';

// Mapping des icônes par section
export const icons = {
  // Navigation principale
  dashboard: HiOutlineChartBar,
  saisie: FiEdit,
  liste: FiUsers,
  statistiques: FiTrendingUp,
  suivi: FiPhone,
  spc: FiTarget,
  alertes: FiBell,
  rapports: FiFileText,
  configuration: FiSettings,
  
  // Actions communes
  add: FiPlus,
  edit: FiEdit2,
  view: FiEye,
  delete: FiTrash2,
  save: FiSave,
  cancel: FiX,
  search: FiSearch,
  filter: FiFilter,
  download: FiDownload,
  upload: FiUpload,
  refresh: FiRefreshCw,
  print: FiPrinter,
  share: FiShare2,
  copy: FiCopy,
  
  // États et notifications
  success: FiCheckCircle,
  error: FiAlertCircle,
  warning: FiAlertTriangle,
  info: FiInfo,
  
  // Authentification
  lock: FiLock,
  unlock: FiUnlock,
  logout: FiLogOut,
  user: FiUser,
  eye: FiEye,
  eyeOff: FiEyeOff,
  
  // Rôles
  admin: FiAward,
  formateur: FiBookOpen,
  lecteur: FiEye,
  
  // Champs de formulaire
  calendar: FiCalendar,
  clock: FiClock,
  email: FiMail,
  location: FiMapPin,
  money: FiDollarSign,
  briefcase: FiBriefcase,
  building: FiHome,
  
  // UI
  chevronDown: FiChevronDown,
  chevronUp: FiChevronUp,
  chevronLeft: FiChevronLeft,
  chevronRight: FiChevronRight,
  close: FiXCircle,
  menu: FiMenu,
  grid: FiGrid,
  list: FiList,
  check: FiCheckSquare,
  uncheck: FiSquare,
  
  // Dashboard spécifique
  home: HiOutlineHome,
  chart: HiOutlineChartBar,
  document: HiOutlineDocumentText,
  users: HiOutlineUserGroup,
  pieChart: HiOutlineChartPie,
  phone: HiOutlinePhone,
  cog: HiOutlineCog6Tooth,
  book: FiBookOpen,
};

// Helper pour obtenir une icône par nom
export const getIcon = (name) => {
  return icons[name] || icons.info;
};

export default icons;

